import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Transition as _Transition, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "notifications"
};
const _hoisted_2 = { class: "notifications-list" };
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "notification-body" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "notification-meta" };
const _hoisted_8 = ["src"];
const _hoisted_9 = {
    key: 0,
    class: "older-notifications-toggle"
};
const _hoisted_10 = { class: "stay-in-loop" };
import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useApi, getHttpInstance, getApiConfig } from '@/composables/useApi';
import { useMoves } from '@/composables/useMoves';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import SwipeActionsContainer from './elements/SwipeActionsContainer.vue';
import MGButton from './elements/MGButton.vue';
const initialCount = 10;
export default /*@__PURE__*/ _defineComponent({
    __name: 'AllNotificationsPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const api = useApi();
        const { getPendingMoves } = useMoves();
        const notifications = ref(null);
        const expandedNotifications = reactive({});
        const showOlderNotifications = ref(false);
        function getNotifications(onSuccess = null) {
            api.GET("/Customers/00000000-0000-0000-0000-000000000000/Notifications", (result) => {
                notifications.value = result;
                if (onSuccess)
                    onSuccess();
            }, true);
        }
        function clearNotificationCache() {
            const config = getApiConfig();
            localStorage.removeItem(config.api + (config.useCachedEndpoints ? '/Cached' : '') + '/Customers/00000000-0000-0000-0000-000000000000/Notifications');
        }
        function markAsDeleteNotification(notificationId, onSuccess = null) {
            getHttpInstance().delete(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Notifications/" + notificationId)
                .then(() => {
                if (onSuccess)
                    onSuccess();
            })
                .catch((result) => {
                if (result.response && result.response.status == 401) {
                    api.refreshLogin(() => {
                        markAsDeleteNotification(notificationId, onSuccess);
                    });
                }
            });
        }
        function getDisplayedNotifications() {
            if (!notifications.value)
                return [];
            if (showOlderNotifications.value)
                return notifications.value;
            return notifications.value.slice(0, initialCount);
        }
        function hasOlderNotifications() {
            if (!notifications.value)
                return false;
            return notifications.value.length > initialCount;
        }
        function getOlderNotificationsCount() {
            if (!notifications.value)
                return 0;
            return notifications.value.length - initialCount;
        }
        function handleAction({ item, action } = { item: null, action: null }) {
            if (!item || !action)
                return;
            if (action.type === 'delete') {
                const updatedNotifications = notifications.value.filter((n) => n.id !== item.id);
                notifications.value = updatedNotifications;
                delete expandedNotifications[item.id];
                markAsDeleteNotification(item.id, () => {
                    clearNotificationCache();
                });
            }
        }
        function toggleExpand(id, event) {
            event.stopPropagation();
            expandedNotifications[id] = !expandedNotifications[id];
        }
        function navigateToPage(notification) {
            event?.stopPropagation();
            clearNotificationCache();
            if (notification.pendingMove) {
                router.push('/moves/' + notification.pendingMove.id);
            }
            else {
                let screen = notification.appScreen || 'Money';
                if (screen === 'noMove') {
                    router.push('/CompletedMoves');
                }
                else {
                    router.push('/' + screen);
                }
            }
        }
        function processMonetaryAmounts(text) {
            if (localStorage.getItem('randomiseFigures') !== 'true') {
                return text;
            }
            const monetaryPattern = /(?:£|$)(?:\d{1,3}(?:,\d{3})*(?:\.\d{2})?|\d+(?:\.\d{2})?)|(?:\d+(?:\.\d{2})?\s*(?:pounds?|pence|p|GBP|USD))/gi;
            return text.replace(monetaryPattern, (match) => {
                if (match.startsWith('£') || match.startsWith('$')) {
                    return match.charAt(0) + '####';
                }
                else {
                    return '####' + match.replace(/^\d+(?:\.\d{2})?/, '');
                }
            });
        }
        function csharpDateTimetoDateTime(dateString, humanificate = true) {
            const date = new Date(dateString);
            if (humanificate) {
                const now = new Date();
                const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                const nowOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                const diffTime = nowOnly.getTime() - dateOnly.getTime();
                const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                const options = { hour: '2-digit', minute: '2-digit' };
                if (diffDays === 0) {
                    return "Today at " + date.toLocaleTimeString([], options);
                }
                else if (diffDays === 1) {
                    return "Yesterday at " + date.toLocaleTimeString([], options);
                }
                else if (diffDays <= 7) {
                    return `${diffDays} days ago at ` + date.toLocaleTimeString([], options);
                }
            }
            return date.toLocaleString([], { hour: '2-digit', minute: '2-digit', year: 'numeric', month: 'numeric', day: 'numeric' });
        }
        onMounted(() => {
            getCustomer();
            getNotifications(() => {
                getPendingMoves(() => {
                    if (notifications.value && state.pendingMoves) {
                        notifications.value = notifications.value.map((notification) => {
                            if (notification.appScreen && notification.appScreen.includes('Moves/')) {
                                const moveGuid = notification.appScreen.split('Moves/')[1];
                                const matchingMove = state.pendingMoves.find((m) => m.move.id === moveGuid);
                                if (matchingMove) {
                                    return {
                                        ...notification,
                                        pendingMove: matchingMove
                                    };
                                }
                                else {
                                    notification.appScreen = 'noMove';
                                }
                            }
                            return notification;
                        });
                    }
                }, false);
            });
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(state).customer)
                    ? (_openBlock(), _createBlock(HeaderBlock, {
                        key: 0,
                        title: "Notifications",
                        bgcolor: "white"
                    }))
                    : _createCommentVNode("", true),
                _createVNode(CustomerLoadWait, { customer: notifications.value }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (notifications.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(SwipeActionsContainer, {
                                        items: getDisplayedNotifications(),
                                        backgroundColor: 'var(--background-color-alt)',
                                        mailStyleSwipe: true,
                                        actions: [
                                            {
                                                image: require('@/assets/trashcan.png'),
                                                type: 'delete',
                                                backgroundColor: 'var(--background-color-alt6)'
                                            }
                                        ],
                                        onActionClick: handleAction
                                    }, {
                                        default: _withCtx(({ item: n }) => [
                                            _createVNode(_component_v_row, {
                                                class: "notificationRow",
                                                onClick: ($event) => (navigateToPage(n))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, {
                                                        cols: "1",
                                                        class: "iconCol"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            (n.pendingMove)
                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                    key: 0,
                                                                    src: require('@/assets/filledbell.png'),
                                                                    class: "icon"
                                                                }, null, 8, _hoisted_3))
                                                                : (_openBlock(), _createElementBlock("img", {
                                                                    key: 1,
                                                                    src: require('@/assets/filledbell.png'),
                                                                    class: "icon opace"
                                                                }, null, 8, _hoisted_4))
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("h2", {
                                                                class: _normalizeClass(["notification-title", { 'normal-weight': !n.pendingMove }])
                                                            }, _toDisplayString(n.title), 3),
                                                            _createElementVNode("div", _hoisted_5, [
                                                                _createElementVNode("p", {
                                                                    class: _normalizeClass({ 'truncated': !expandedNotifications[n.id] })
                                                                }, _toDisplayString(processMonetaryAmounts(n.body || '')), 3),
                                                                (n.body && n.body.length > 100)
                                                                    ? (_openBlock(), _createElementBlock("a", {
                                                                        key: 0,
                                                                        onClick: (e) => toggleExpand(n.id, e),
                                                                        class: "more-link"
                                                                    }, _toDisplayString(expandedNotifications[n.id] ? 'Less' : 'More'), 9, _hoisted_6))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            _createElementVNode("div", _hoisted_7, [
                                                                _createElementVNode("small", null, "Sent " + _toDisplayString(csharpDateTimetoDateTime(n.sentDateTime)), 1),
                                                                _createElementVNode("img", {
                                                                    src: require('@/assets/arrow-right.png'),
                                                                    class: "rightIcon"
                                                                }, null, 8, _hoisted_8)
                                                            ])
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                _: 2
                                            }, 1032, ["onClick"])
                                        ]),
                                        _: 1
                                    }, 8, ["items", "actions"])
                                ]),
                                (hasOlderNotifications())
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                        _createVNode(MGButton, {
                                            outline: true,
                                            noCaps: true,
                                            text: showOlderNotifications.value ? 'Hide older notifications' : `Show ${getOlderNotificationsCount()} previous notifications`,
                                            onClick: _cache[0] || (_cache[0] = ($event) => (showOlderNotifications.value = !showOlderNotifications.value))
                                        }, null, 8, ["text"])
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_10, [
                                    _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Stay in the loop", -1)),
                                    _cache[3] || (_cache[3] = _createElementVNode("p", null, "Make sure you have notifications enabled for the Money Guided app.", -1)),
                                    _createVNode(MGButton, {
                                        outline: true,
                                        arrow: true,
                                        noCaps: true,
                                        text: "Notification settings",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (_unref(router).push('notifications')))
                                    })
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
